import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type ReferrerState = {
  referrerId?: string;
};

const initialState: ReferrerState = {
  referrerId: undefined,
};

const slice = createSlice({
  name: 'referrer',
  initialState,
  reducers: {
    setReferrerId: (state, action: PayloadAction<string>) => ({
      ...state,
      referrerId: action.payload,
    }),
  },
});

export const referrerReducer = slice.reducer;
export const { setReferrerId } = slice.actions;
